// src/AdminPages/AdminFooter/AdminFooter.jsx

import React from 'react';
import './AdminFooter.css';

const AdminFooter = () => {
  return (
    <footer className="admin-footer-layout">
      <div className="admin-footer-accent-line"></div>
      <div className="admin-footer-layout-container">
        
        {/* Left: Copyright */}
        <div className="admin-footer-layout-left">
          <p>
            © 2026 <strong>Nutrivio Medical Services Private Limited</strong>. All Rights Reserved.
          </p>
        </div>

        {/* Right: Developer Credit */}
        <div className="admin-footer-layout-right">
          <p>
            Developed & Designed With <span className="admin-footer-layout-heart">❤️</span> By 
            <a 
              href="https://dheersoftwaresolutions.com" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="admin-footer-layout-link"
            >
              Dheer Software Solutions
            </a>
          </p>
        </div>

      </div>
    </footer>
  );
};

export default AdminFooter;